import Button from '../../shared/buttons/button';
import { CheckSmsKeyRequestDataType } from '../../../api/temp-user';

export type MobileData = CheckSmsKeyRequestDataType;
export type MobilePropsType = {
  mobile: string;
  onBack: () => void;
  className?: string;
};

function MobileView({ mobile, onBack, className }: MobilePropsType) {
  return (
    <div data-testid='smskey-mobile-view' className={className}>
      <p className='my-6 mt-8'>
        <span>شماره تلفن همراه: </span>
        <span>{mobile}</span>
      </p>
      <Button outline content='تغییر شماره تلفن همراه' onClick={onBack} className='mx-auto my-4' />
    </div>
  );
}

export default MobileView;
